module.exports = _.replace;